import React from 'react';

const QuestionNav = ({ total, current, answered, onSelect }) => {
  return (
    <div className="flex items-center space-x-1">
      {Array.from({ length: total }, (_, i) => {
        const isAnswered = answered[i];
        const isCurrent = current === i;
        const isAdjacent = Math.abs(i - current) <= 3;
        
        // Show only current, answered, and nearby dots
        if (!isAdjacent && !isAnswered && !isCurrent) {
          if (i === current + 4 || i === current - 4) {
            return (
              <span key={i} className="text-gray-300 text-xs select-none">
                ...
              </span>
            );
          }
          return null;
        }
        
        return (
          <button
            key={i}
            onClick={() => onSelect(i)}
            className={`
              w-2 h-2 rounded-full transition-all duration-200
              ${isCurrent ? 'w-4 h-2 rounded-full bg-[#ff9f2f]' : ''}
              ${!isCurrent && isAnswered ? 'bg-green-400' : ''}
              ${!isCurrent && !isAnswered ? 'bg-red-400 hover:bg-red-500' : ''}
              hover:scale-125 hover:bg-[#ff9f2f]
              ${!isAnswered && !isCurrent ? 'cursor-pointer' : ''}
            `}
            aria-label={`Go to question ${i + 1} - ${isAnswered ? 'Answered ✅' : 'Unanswered ❌'}`}
            title={`Question ${i + 1} - ${isAnswered ? 'Answered ✅' : 'Unanswered ❌'}`}
          />
        );
      })}
    </div>
  );
};

export default QuestionNav;